module.exports = __webpack_public_path__ + "static/media/Jaya Charbarneau Headshot.95ef3d47.jpeg";